import { render, staticRenderFns } from "./MensagensAgendadas.vue?vue&type=template&id=acd8267a&scoped=true"
import script from "./MensagensAgendadas.vue?vue&type=script&lang=js"
export * from "./MensagensAgendadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd8267a",
  null
  
)

export default component.exports